import * as React from "react";

interface AspectRatioProps extends React.HTMLAttributes<HTMLDivElement> {
  width: number;
  height: number;
}

export const AspectRatio: React.FC<AspectRatioProps> = (props) => {
  const { children, style, width, height, ...rest } = props;
  return (
    <div
      {...rest}
      css={`
        position: relative;
        height: 0;

        img,
        svg {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      `}
      style={{
        paddingBottom: `calc(${Number((height / width).toFixed(12))} * 100%)`,
        ...style,
      }}
    >
      {children}
    </div>
  );
};
